export default __webpack_public_path__ + "static/media/Montserrat-Medium.c86e3b90.ttf";